import React, { useState, useEffect, useRef  } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useNavigate, useParams, useLocation  } from 'react-router-dom';

import FileBrowser from "./FileBrowser"; 

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import FirstNews from './FirstNews';


const Kepegawaian = () =>{
    
    const [items, setItems] = useState([]);
    const { id } = useParams();
    const navigate = useNavigate();

    const [markdownContents, setMarkdownContents] = useState({});     
    const location = useLocation();
    const relativePath = decodeURIComponent(location.pathname.replace("/kepegawaian", "").replace(/^\/+/, ""));

   

   
  return(
        <div>
            <div class="ttm-page-title-row">
                <div class="ttm-page-title-row-inner  ttm-bgcolor-darkgrey">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-12" style={{textAlign:'left'}}>
                                <div class="page-title-heading">
                                    <h2 class="title">Bagian Kepegawaian</h2>
                                </div>
                                <div class="breadcrumb-wrapper">
                                    <span><a class="pathway" href="/">Home</a></span><span><a class="pathway" href="/profil"> Profil</a></span>                              
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="site-main">
                <div class="ttm-row sidebar ttm-sidebar-right ttm-bgcolor-white clearfix" style={{paddingTop: "0px"}}>
                    <div class="container">                    
                        <div class="row">
                            <div class="col-xl-9 col-lg-8 content-area" style={{textAlign:'left'}}>
                            <article class="post ttm-blog-single clearfix">
    
        <div class="ttm-blog-single-content">
            <div class="entry-content mt-5">
                <div class="ttm-box-desc-text">
 <div>
  
        <FileBrowser 
            folderBase="/documents/kepegawaian"  bag="kepegawaian"
            />

    </div>

                </div>
            </div>
        </div>
    
    </article>                          
                            </div>
                            <div class="col-xl-3 col-lg-4 widget-area sidebar-right ttm-col-bgcolor-yes ttm-bg ttm-right-span ttm-bgcolor-grey pt-60 mb_60 pb-60 res-991-mt-0 res-991-pt-0">
                                <div class="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>

                            <FirstNews />
                </div>
                        </div>
                    
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Kepegawaian;